import { Alert, Button, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import OrderSummary from "./OrderSummary";
import WushCard from "../../layout/WushCard";
import { useNavigate } from "react-router-dom";
import WushPopover from "../../layout/WushPopover";
import OrderRefundForm from "../../form/orders/OrderRefundForm";
import OrderRefunds from "./OrderRefunds";
import { useState } from "react";

const CustomerPaidAlert = ({ order }) => {
  if(order.payment_type === 'cash') return (
    <Alert severity="info">Customer paid <b>${order.total_price_with_fees_dollars}</b> in cash on {format(new Date(order.payment_confirmed_at), 'MM/dd/yyyy @ hh:mm aa')}</Alert>
  );
  if(order.payment_type === 'stripe') return (
    <Alert severity="info">Customer paid <b>${order.payment_intent_amount_received_dollars}</b> with card via Stripe on {format(new Date(order.payment_confirmed_at), 'MM/dd/yyyy @ hh:mm aa')}</Alert>
  );
};

export default function OrderReview({ order }) {
  const [refundPopoverClosed, setRefundPopoverClosed] = useState(false);
  const navigate = useNavigate();

  return (
    <Stack gap={2}>
      <Stack direction="row" className="hide-print">
        <Button onClick={() => navigate('/orders')}>
          Back to Orders
        </Button>
      </Stack>
      <Stack className="hide-print">
        <Typography variant="h3">Order #{order.id}</Typography>
      </Stack>
      <Stack>
        <CustomerPaidAlert order={order} />
      </Stack>
      <Stack direction="row" className="hide-print" spacing={2}>
        <Button onClick={() => window.print()} variant="contained">
          Print
        </Button>
        {order.payment_intent_succeeded_at && <WushPopover
          anchor={
            <Button variant="outlined">
              Create Refund
            </Button>
          }
          forceClose={refundPopoverClosed}
        >
          <Stack p={2}>
            <OrderRefundForm
              order={order}
              afterCreate={() => {
                setRefundPopoverClosed(true);
                setInterval(() => setRefundPopoverClosed(false), 100);
              }}
            />
          </Stack>
        </WushPopover>}
      </Stack>
      <Stack>
        <WushCard>
          <Stack p={2}>
            <OrderSummary order={order} />
          </Stack>
        </WushCard>
      </Stack>
      <Stack>
        <OrderRefunds order={order} />
      </Stack>
    </Stack>
  );
}